<template>
    <div
        class="mvt-range group-range"
        :class="theme"
        role="group"
        :aria-label="label || undefined"
    >
        <button
            v-for="(item, index) in data"
            :key="index"
            type="button"
            v-ga:clickable="item.value"
            :disabled="disabled || item.disabled"
            :min="_value[0] === item.value || undefined"
            :max="(_value[1] !== 0 && _value[1] === item.value) || (_value[1] === _value[0] && _value[0] === item.value) || undefined"
            @click="changeRange(item.value)"
            v-html="item.text"
        ></button>
    </div>
</template>
<script src="./mvt-range.js"></script>

<style lang="scss">
    @use "./mvt-range.scss" as *;
</style>
